<div class="container">
  <div class="community-container">
    <img class="onions" src="assets/merchant-landing-page/onions.png" alt="Onions">
    <img class="leaf" src="assets/merchant-landing-page/leaf.png" alt="Leaf">
    <div class="community-background">
        <h2 i18n>Join Our Culinary Community Today: Start Selling in Minutes!</h2>
        <button i18n class="button-primary" routerLink="/merchants/signup" routerLinkActive="active">Get Started</button>
    </div>
  </div>
</div>
